export default __webpack_public_path__ + "3.69.1/assets/75f3f6ea59cb37befab97f7a5ff7b542.jpg";